/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Modal, Card, Button } from "flowbite-react";
import React, { useCallback, useState } from "react";
import { request } from "../../../config/helpers/axios-instance";
import NameAndBatchComponent from "./NameBatchComponent";

const extractFilename = (url) => {
    try {
        return new URL(url).pathname.split("/").pop();
    } catch {
        return url.split("/").pop()?.split("?")[0] || url;
    }
};

const PdfViewer = ({ url }) => {
    const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;
    return (
        <iframe
            src={viewerUrl}
            title="Prescription PDF"
            className="w-full border border-gray-200 rounded"
            style={{ height: "600px", minHeight: "400px" }}
            sandbox="allow-scripts allow-same-origin"
        />
    );
};

const PrescriptionModal = ({ updatePrescription, prescription, onClose, show, onlyShow, updateItem, addNewItem }) => {
    const [downloading, setDownloading] = useState(false);

    const handleDownloadAll = useCallback(() => {
        const links = prescription?.links;
        if (!links || links.length === 0) return;

        setDownloading(true);
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);

        links.forEach((link, index) => {
            setTimeout(() => {
                const fileName = link.split("/").pop()?.split("?")[0] || `prescription-${index + 1}`;
                a.setAttribute("href", link);
                a.setAttribute("download", fileName);
                a.click();
                if (index === links.length - 1) {
                    document.body.removeChild(a);
                    setDownloading(false);
                }
            }, 1000 * index);
        });
    }, [prescription]);

    const handleAddFile = async (e) => {
        const { files } = e.target;
        let formData = new FormData();
        for (let i in files) {
            formData.append('files', files[i]);
        }
        let resUploadImage = await request({ url: "/file/upload/prescription/", method: "POST", data: formData, headers: { "Content-Type": "multipart/form-data" } })
        if (resUploadImage && resUploadImage.status === 200 && resUploadImage.data.success) {
            const uploadedImage = resUploadImage?.data?.data;
            const newImages = prescription?.links?.map(extractFilename) || [];
            uploadedImage.forEach((item) => {
                const fileKey = extractFilename(item.image || item.pdf);
                if (!newImages.includes(fileKey)) {
                    newImages.push(fileKey);
                }
            })
            await request({ url: `/prescription/admin/${prescription.id}`, method: "PUT", data: { links: newImages }, headers: { "Content-Type": "application/json" } });
            updatePrescription(newImages)
        }
    }

    const handleDeleteImage = async (image) => {
        let newImages = prescription.links.filter((item) => item !== image);
        await request({ url: `/prescription/admin/${prescription.id}`, method: "PUT", data: { links: newImages } })
        updatePrescription(newImages)
    }

    return (
        <React.Fragment >
            <Modal size="7xl" show={show} onClose={() => { onClose() }} dismissible>
                <Modal.Header className='bg-[white]' >
                    <div className="flex items-center gap-4">
                        Prescriptions
                        {prescription?.links?.length > 0 && (
                            <button
                                onClick={handleDownloadAll}
                                disabled={downloading}
                                className="px-3 py-1 text-sm bg-green-600 text-white-50 rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {downloading ? "Downloading..." : "Download All"}
                            </button>
                        )}
                    </div>
                </Modal.Header>
                <Modal.Body className="bg-[white] overflow-y-scroll">
                    <div>
                        {
                            prescription?.links?.length > 0 ?
                                prescription?.links?.map(link => {
                                    if (link.includes(".pdf")) {
                                        return <div key={link} className="shrink-0" style={{ marginBottom: "20px" }}>
                                            <PdfViewer url={link} />
                                            {!onlyShow && <button onClick={() => handleDeleteImage(link)} className="w-full rounded-sm bg-[red]/[0.4] hover:bg-[red]/[0.6]" >Delete</button>}
                                            <hr />
                                        </div>
                                    } else {
                                        return <div key={link} className="shrink-0" style={{ marginBottom: "20px" }}>
                                            <Card imgSrc={link} />
                                            {!onlyShow && <button onClick={() => handleDeleteImage(link)} className="w-full rounded-sm bg-[red]/[0.4] hover:bg-[red]/[0.6]" >Delete</button>}
                                            <hr />
                                        </div>
                                    }
                                }
                                )
                                : "No Prescription Found !"
                        }
                        {!onlyShow && <input type='file' multiple onChange={handleAddFile} />}
                    </div>
                    {/* <div className="col-span-1" >
                        <NameAndBatchComponent type="Add" addNewItem={addNewItem} updateItem={updateItem} onClose={onClose} />
                    </div> */}
                </Modal.Body>
            </Modal>
        </React.Fragment >
    )
}

export default PrescriptionModal;